import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {getSameDayLastMonth} from '/redux/action/coach.action';
import {getTeamsMetrics} from '/redux/action/metric.action';
import {hasSameDayLastMonthById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {hasTeamsMetricsById} from '/redux/selector/metric.teams.selector';
import {generateCallback} from '/util/component.util';
import {withProps} from '/util/selector.util';

import Teams from './Teams';

const withCurrentUserCoachId = withProps({coachId: userId});
export default connect(
  createStructuredSelector({
    userId,
    hasTeamsMetricsById: withCurrentUserCoachId(hasTeamsMetricsById),
    hasSameDayLastMonth: withCurrentUserCoachId(hasSameDayLastMonthById),
  }),
  dispatch => ({
    getTeamsMetrics: generateCallback({
      func: dispatch,
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      params: getTeamsMetrics(),
    }),
    getSameDayLastMonth: ({coachId}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getSameDayLastMonth({coachId})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    const {userId: coachId} = stateProps;
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      getSameDayLastMonth: () =>
        Promise.all([
          dispatchProps.getSameDayLastMonth({
            coachId,
          }),
        ]),
    };
  },
)(Teams);
